import * as paymentManager from '$domain/model/payment/payment.manager'

export const offSessionPaymentClientSecretId = requestId => paymentManager.getOffSessionPaymentClientSecretId(requestId)



// WEBPACK FOOTER //
// ./src/services/payment/offSessionClientSecretIdRecovery/offSessionClientSecretIdRecovery.service.ts